
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll("[data-product-gallery]").forEach((el) => {
        const buttons = el.querySelectorAll("button");
        const images = el.querySelector("[data-product-gallery-images]").children;

        buttons.forEach((button, i) => {
            button.addEventListener('click', () => {
                const activeImage = el.querySelector("[data-product-gallery-images] > *:not(.hidden)");
                const activeButton = el.querySelector("button.border");

                if (activeButton) {
                    activeButton.classList.remove("border");
                }

                if (activeImage) {
                    activeImage.classList.add("hidden");
                }


                button.classList.add("border");

                images[i].classList.remove("hidden");
            });
        });
    })
});